<div class="expand-widget-dialog">
    <em class="fas fa-times fa-1_5x text-danger cursor-pointer icon-btn icon-btn--pos-t-r" (click)="closeDialog()"></em>
    <ng-container *ngComponentOutlet="data.component"></ng-container>
</div>
